"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var getPixelRatio_1 = require("../getPixelRatio");
var PI = Math.PI;
var PI2 = PI * 2;
function isTouch(e) {
    return e.nativeEvent instanceof TouchEvent;
}
function getTimeStamp() {
    return Date.now();
}
function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
}
var Circle = /** @class */ (function () {
    function Circle(x, y, maxRadius, maxOpacity, duration) {
        this.x = x;
        this.y = y;
        this.radius = 0;
        this.maxRadius = maxRadius;
        this.opacity = 0;
        this.maxOpacity = maxOpacity;
        this.duration = duration;
        this.createdAt = getTimeStamp();
    }
    Circle.prototype.update = function () {
        var progress = (getTimeStamp() - this.createdAt) / this.duration;
        var easing = easeOutQuint(progress);
        this.radius = this.maxRadius * easing;
        this.opacity = (1 - easing) * this.maxOpacity;
    };
    return Circle;
}());
var Ripple = /** @class */ (function (_super) {
    __extends(Ripple, _super);
    function Ripple() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.frame = -1;
        _this.color = 'transparent';
        _this.radius = 0;
        _this.circles = [];
        _this.context = null;
        _this.canvasRef = React.createRef();
        _this.state = {
            width: 0,
            height: 0,
            pixelRatio: 1,
        };
        _this.update = function () {
            var current = _this.canvasRef.current;
            if (current === null) {
                return;
            }
            _this.context = current.getContext('2d');
            if (_this.context === null) {
                return;
            }
            if (_this.circles.length <= 0) {
                _this.stop();
            }
            var _a = _this.state, width = _a.width, height = _a.height, pixelRatio = _a.pixelRatio;
            _this.frame = window.requestAnimationFrame(_this.update);
            _this.context.clearRect(0, 0, width, height);
            for (var i = 0, length_1 = _this.circles.length; i < length_1; i++) {
                var circle = _this.circles[i];
                _this.context.save();
                _this.context.fillStyle = _this.color;
                _this.context.beginPath();
                _this.context.globalAlpha = circle.opacity;
                _this.context.arc(circle.x * pixelRatio, circle.y * pixelRatio, circle.radius, 0, PI2);
                _this.context.fill();
                _this.context.restore();
                circle.update();
                if (getTimeStamp() >= circle.createdAt + circle.duration) {
                    _this.circles.splice(i, 1);
                    i--;
                    length_1--;
                }
            }
        };
        _this.onPress = function (e) {
            if (isTouch(e)) {
                var changedTouches = e.changedTouches;
                var _a = changedTouches[0], clientX = _a.clientX, clientY = _a.clientY;
                _this.createCircle(clientX, clientY);
            }
            else if (e.button === 0 && !e.ctrlKey) {
                var clientX = e.clientX, clientY = e.clientY;
                _this.createCircle(clientX, clientY);
            }
        };
        _this.onRelease = function (e) { };
        _this.createCircle = function (clientX, clientY) {
            var current = _this.canvasRef.current;
            if (current) {
                _this.context = current.getContext('2d');
                if (_this.context === null)
                    return;
                var _a = current.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom, left_1 = _a.left, right = _a.right;
                var color = window.getComputedStyle(current).color;
                var pixelRatio = getPixelRatio_1.getPixelRatio(_this.context);
                var width = (right - left_1) * pixelRatio;
                var height = (bottom - top_1) * pixelRatio;
                var maxRadius_1 = Math.max(height, width);
                _this.color = color || _this.color;
                _this.setState({ width: width, height: height, pixelRatio: pixelRatio }, function () {
                    var circle = new Circle(clientX - left_1, clientY - top_1, maxRadius_1, _this.props.opacity || 0.5, _this.props.duration || 1500);
                    _this.circles.push(circle);
                    if (_this.frame === -1)
                        _this.start();
                });
            }
        };
        _this.start = function () {
            _this.frame = window.requestAnimationFrame(_this.update);
        };
        _this.stop = function () {
            if (_this.frame !== -1) {
                window.cancelAnimationFrame(_this.frame);
                _this.frame = -1;
            }
        };
        _this.getProps = function () {
            var disabled = _this.props.disabled;
            return disabled
                ? {}
                : {
                    onMouseDown: _this.onPress,
                    onMouseUp: _this.onRelease,
                    onMouseLeave: _this.onRelease,
                    onTouchStart: _this.onPress,
                    onTouchEnd: _this.onRelease,
                    onTouchCancel: _this.onRelease,
                };
        };
        return _this;
    }
    Ripple.prototype.componentWillUnmount = function () {
        this.stop();
    };
    Ripple.prototype.render = function () {
        var style = this.props.style;
        var _a = this.state, width = _a.width, height = _a.height;
        return (React.createElement("canvas", __assign({ width: width, height: height, style: style, ref: this.canvasRef, className: styles.ripple }, this.getProps())));
    };
    return Ripple;
}(React.PureComponent));
exports.default = Ripple;
